import React, { useEffect } from "react"
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { isShow504Error } from "../../Epics/MyAccounts/selectors";
import { hide504Error } from "../../Epics/MyAccounts/actions";
import Message from "./MessageComponent";


export const MessageBox = ({is504,history,clearError})=>{

    const hideMessage = (unlisten)=>{
        unlisten();
        clearError()
    }
    useEffect(()=>{
       const unlisten  =  history.listen((loc)=>{
            hideMessage(unlisten);
        })
    },[])


    return (
       is504?
       <Message show ={true}>
          We've Successfully received your request please allow up to one full business day for your changes to take effect .You don't need to take any action at this time
          </Message>
      :null
    )
}


const mapStateToProps = (state) => ({
    is504: isShow504Error(state.toJS())
});

export const mapDispatchToProps = (dispatch) => ({
    clearError: () => dispatch(hide504Error())
})

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(MessageBox));


